import { createContext } from "react";
import { RouteLoader } from "./loader.js";
import { proxy } from "valtio";
const NOOP_ROUTE = {
    component: () => null,
    id: "initial",
    hash: "",
    key: "initial",
    pathname: "",
    props: {},
    uri: "",
    view: "_unknown",
    search: "",
    query: {},
    returnState: undefined,
    meta: {},
};
export const RouterContext = createContext({
    loader: new RouteLoader(),
    async navigate(url) { },
    async prefetch(url) { },
    async preload(url) { },
    subscribe(fn) {
        return () => { };
    },
    replaceHash(hash) { },
    replaceQuery(query) { },
    handleClickEvent(e, originalHref) { },
    emitEvent(event) { },
    getState() {
        return null;
    },
    restoreRoute(route) { },
});
export const RouterStateContext = createContext({
    history: [NOOP_ROUTE],
    activeRoute: NOOP_ROUTE,
    blockers: [],
});
export const RouteItemContext = createContext(NOOP_ROUTE);
export const clientMetaTags = proxy({
    tags: null,
    setMetaTags(tags) {
        clientMetaTags.tags = tags;
    },
});
